module.exports = __webpack_public_path__ + "static/ADC_smart_thermostat-f60441f75f3908bf6d9bf8e304fc12b8.jpg";